import FintechOutageBannerTitle from './FintechOutageBannerTitle';
import { ACTION_CONTEXTS } from '../constants/actionContexts.constants';
import { THIRD_PARTY_SERVICES } from '../constants/thirdPartyServices.constants';
import FintechOutageBannerMessage from './FintechOutageBannerMessage';
import { FireAlarm } from 'foundations-components/transitional/components/FireAlarm';
import { Text } from 'foundations-components/components/Text';
import { jsx as _jsx } from "react/jsx-runtime";
const FintechOutageBanner = ({
  availabilityStatus,
  requiredServices = [THIRD_PARTY_SERVICES.ZUORA],
  actionContext = ACTION_CONTEXTS.ANY,
  className
}) => {
  if (requiredServices.indexOf(THIRD_PARTY_SERVICES.ZUORA) > -1) {
    const zuoraStatus = availabilityStatus.zuora;
    const isZuoraDown = zuoraStatus.isDown;
    if (isZuoraDown) {
      return /*#__PURE__*/_jsx(FireAlarm, {
        closeable: false,
        type: "warning",
        titleText: /*#__PURE__*/_jsx(FintechOutageBannerTitle, {
          actionContext: actionContext,
          serviceAvailabilityStatus: zuoraStatus
        }),
        marginBlockEnd: className === 'm-bottom-4' ? '400' : '0',
        children: /*#__PURE__*/_jsx(Text, {
          as: "p",
          children: /*#__PURE__*/_jsx(FintechOutageBannerMessage, {
            serviceAvailabilityStatus: zuoraStatus
          })
        })
      });
    }
  }
  return null;
};
export default FintechOutageBanner;